import React from 'react';
import { getServiceLocationBase } from '../../common/api/data';
import { useState, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Multiselect from 'multiselect-react-dropdown';

import MagicTable from "../../common/ui/magictable";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  ScaleControl,
  Tooltip,
  //useMap,
} from 'react-leaflet';

import { Icon } from 'leaflet';

//import { parseISO, format } from 'date-fns'

//const formatDate = (dateString) => {
//	return dateString === undefined ? 'Loading...' : format(parseISO(dateString), "MM/dd/yyyy h:mm:ss a");
//}

const houseIcon = new Icon({
	iconUrl: 'assets/house.png',
	iconSize: [27, 27], // size of the icon
	iconAnchor: [14, 14], // point of the icon which will correspond to marker's location
	popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor

});

const formatPrice = (n) => {
	var ds = '';
	for (let i = 1; i <= n; i++) {
		ds = ds + '$';
	}
	return ds;
};

const chooseIcon = (color, available) => {
	let arrowColor = color;
	if (available === 'Closed') {
		arrowColor = 'gray';
	}
	var icon = new Icon({
		iconUrl: `assets/${arrowColor}_arrow.png`,
		iconSize: [15, 41], // size of the icon
		iconAnchor: [8, 41], // point of the icon which will correspond to marker's location
		//popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
	});
	return icon;
};

const formatOpen = (n) => {
	return n === '0' ? 'Closed' : 'Open';
};

const has = (list, element) => {
	//console.log(list);
	//console.log(element);
	return list
	.filter((s) => s.id === element)
	.length > 0;
};

interface RestaurantHome {
	id: string,
	restaurant_home_id: number,
	tag: string,
	description: string,
	latitude: number,
	longitude: number,
}

interface Restaurant {
	id: string,
	//objectId: number,
	name: string,
	type: string,
	minutes: string,
	price: string,
	available: string,
	description: string,
	created: string,
	latitude: number,
	longitude: number,
	restaurantType: {
		restaurantTypeId: number,
		restaurantTypeDescription: string,
		restaurantTypeColor: string,
		created: string,
	},
}

interface DropDownOption {
	id: string,
	label: string,
}

const Restaurants = () => {
	const [data, setData] = useState<Restaurant[]>([]);
	const [rhome, setRhome] = useState<RestaurantHome>({id: '', restaurant_home_id: 0, tag: '', description: '', latitude: 0, longitude: 0});
	const [queryParams] = useSearchParams();
	const [loading, setLoading] = useState<boolean>(true);

	const [selectedTypes, setSelectedTypes] = useState<DropDownOption[]>([]);
	const [selectedAvailabilities, setSelectedAvailabilities] = useState<DropDownOption[]>([]);
	const [selectedPrices, setSelectedPrices] = useState<DropDownOption[]>([]);

	const typeOptions = [
		{ id: '1', label: 'Fast Food' },
		{ id: '2', label: 'Self Seat' },
		{ id: '3', label: 'Sit Down' },
		{ id: '4', label: 'Food Court' },
		{ id: '5', label: 'Buffet' },
	];

	const availabilityOptions = [
		{ id: 'Closed', label: 'Closed' },
		{ id: 'Open', label: 'Open' },
	];

	const priceOptions = [
		{ id: '$', label: '$' },
		{ id: '$$', label: '$$' },
		{ id: '$$$', label: '$$$' },
		{ id: '$$$$', label: '$$$$' },
		{ id: '$$$$$', label: '$$$$$' },
	];

	const pageLoadFunction = async () => {
		loadDashboardData('restaurants');
		setSelectedTypes(typeOptions);
		setSelectedAvailabilities(availabilityOptions);
		setSelectedPrices(priceOptions);
	};

	useEffect(() => {pageLoadFunction();}, []);

	const loadDashboardData = (type) => {
		// console.log('this.queryParams');
		console.log(`queryParams: ${queryParams.get('tag')}`);
		//alert('loadDataShortWay')
		console.log('loadDataShortWay');
		fetch(getServiceLocationBase() + '/shoppingitems/' + type + '/' + queryParams.get('tag') ).then(r => {
			r.json().then(j => {
				console.log('json');
				//console.log(j);
				// set j to your page variable or do whatever with it
				for (let i = 0; i < j.restaurants.length; i++) {
					//console.log(j[i]);
					j.restaurants[i].price = formatPrice(j.restaurants[i].price);
					j.restaurants[i].available = formatOpen(j.restaurants[i].available);
				}
				setRhome(j.home);
				setData(j.restaurants);
				setLoading(false);
			})
			.catch(f => {
				console.log('json error');
				console.log(f);
			});
		})
		.catch(e => {
			console.log('fetch error');
			console.log(e);
		});
	};

	const columns = useMemo(
		() => [
			{
                Header: () => (<div className={"names"}>Name</div>),
                Cell: row => (<div className={"names"}>{row.value}</div>),
				accessor: "name",
			},
			{
                Header: () => (<div className={"names"}>Type</div>),
                Cell: row => (<div className={"names"}>{row.value}</div>),
				accessor: "restaurantType.restaurantTypeDescription",
			},
			{
                Header: () => (<div className={"numbers"}>Mins</div>),
                Cell: row => (<div className={"numbers"}>{row.value}</div>),
				accessor: "minutes",
			},
			{
                Header: () => (<div className={"numbers"}>Price</div>),
                Cell: row => (<div className={"numbers"}>{row.value}</div>),
				accessor: "price",
			},
			{
                Header: () => (<div className={"numbers"}>Status</div>),
                Cell: row => (<div className={"numbers"}>{row.value}</div>),
				accessor: "available",
			},
			{
                Header: () => (<div className={"names"}>Notes</div>),
                Cell: row => (<div className={"descriptions"}>{row.value}</div>),
				accessor: "description",
			},
		],
		[]
	);

	const renderTypePicker = () => {
		return (
			<div className="filterLarger dropdown">
				<Multiselect
					isObject={true}
					options={typeOptions}
					showCheckbox={true}
					onSelect={(e) => {setSelectedTypes(e);} }
					onRemove={(e) => {setSelectedTypes(e);} }
					selectedValues={selectedTypes}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Choose type(s)'
				/>
			</div>
		);
	};

	const renderAvailabilityPicker = () => {
		return (
			<div className="filterLarger dropdown">
				<Multiselect
					isObject={true}
					options={availabilityOptions}
					showCheckbox={true}
					onSelect={(e) => {setSelectedAvailabilities(e);} }
					onRemove={(e) => {setSelectedAvailabilities(e);} }
					selectedValues={selectedAvailabilities}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Choose availability'
				/>
			</div>
		);
	};

	const renderPricePicker = () => {
		return (
			<div className="filterLarger dropdown">
				<Multiselect
					isObject={true}
					options={priceOptions}
					showCheckbox={true}
					onSelect={(e) => {setSelectedPrices(e);} }
					onRemove={(e) => {setSelectedPrices(e);} }
					selectedValues={selectedPrices}
					displayValue='label'
					avoidHighlightFirstOption={true}
					hideSelectedList={true}
					keepSearchTerm={false}
					showArrow={true}
					placeholder='Choose price(s)'
				/>
			</div>
		);
	};

	const renderRestaurantMap = () => {
		return (
			<span id="map">
				<MapContainer center={[rhome.latitude, rhome.longitude]} zoom={14} scrollWheelZoom={true}>
					<TileLayer
						attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
						url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					/>
					{data
						.filter((r) => has(selectedTypes, r.type) )
						.filter((r) => has(selectedAvailabilities, r.available) )
						.filter((r) => has(selectedPrices, r.price) )
						.map((r) => (
							<span key={r.id}>
								<Marker icon={chooseIcon(r.restaurantType.restaurantTypeColor, r.available)} position={[r.latitude, r.longitude]}>
									<Popup>
										<strong><u>{r.name}</u></strong><br />
										{r.restaurantType.restaurantTypeDescription}<br />
										{r.price}<br />
										{r.description}<br />
									</Popup>
									<Tooltip opacity={0.4} permanent={true} sticky={true}>{r.name}</Tooltip>
								</Marker>
							</span>
						))
					}
					<Marker icon={houseIcon} position={[rhome.latitude, rhome.longitude]} alt={rhome.description} title={rhome.description} />
					<ScaleControl position="bottomright" metric={false} />
				</MapContainer>
			</span>
		);
	};

	return (
		<div>
			<h1>Local Restaurants</h1>
			{
				loading ? 'Loading...' : <span>
					<table>
						<tbody>
							<tr>
								<td width='40%'>
									<table className={"mainRestaurantsTable"} width='100%'>
										<tbody>
											<tr>
												<td style={{ verticalAlign: 'top' }}><MagicTable title={'Restaurants'} columns={columns} data={data} /></td>
											</tr>
										</tbody>
									</table>
								</td>
								<td width='60%' valign='top'>
									<span className="filters">
										{renderTypePicker()}
										{renderPricePicker()}
										{renderAvailabilityPicker()}
									</span>
									{renderRestaurantMap()}
								</td>
							</tr>
						</tbody>
					</table>
				</span>
			}
		</div>
	);

};

export default Restaurants;
